import { createRouter, createWebHistory } from "vue-router";
import { getToken, getUserInfo, removeToken, removeUserInfo } from "@/utils/auth";
import store from '@/store';
import { Message } from 'view-ui-plus';
import { fromAuthor } from "@/api";
import { isMobileDevice } from "@/utils/utils";
const routes = [
    {
        path: "/",
        name: "Layout",
        component: isMobileDevice() ? () => import('@/views/mobile/Layout/Layout.vue') : () => import('@/views/desktop/Layout/Layout.vue'),
        redirect: '/home',
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: '/home',
                name: "home",
                meta: {
                    requiresAuth: true
                },
                component: isMobileDevice() ? () => import('@/views/mobile/home/home.vue') : () => import('@/views/desktop/home/home.vue')
            },
            {
                path: '/my-space',
                name: "PDFlist",
                meta: {
                    requiresAuth: true
                },
                component: isMobileDevice() ? () => import('@/views/mobile/PDFlist/PDFlist.vue') : () => import('@/views/desktop/PDFlist/PDFlist.vue'),
            },
            {
                path: '/community',
                name: "Community",
                meta: {
                    requiresAuth: true
                },
                component: () => import('@/views/desktop/community/community.vue'),
            },
            {
                path: '/my-space/folders/:bid',
                name: 'mySpaceFolders',
                meta: {
                    requiresAuth: true
                },
                component: () => import('@/views/desktop/PDFlist/folders/index.vue')
            },
            {
                path: '/my-avatar',
                name: "Permi",
                meta: {
                    requiresAuth: true
                },
                component: isMobileDevice() ? () => import('@/views/mobile/permi/permi.vue') : () => import('@/views/desktop/permi/permi.vue')
            },
            {
                path: '/account',
                name: "Account",
                meta: {
                    requiresAuth: true
                },
                component: () => import('@/views/mobile/my/my.vue')
            },
            {
                path: '/asset',
                name: "Asset",
                meta: {
                    requiresAuth: true
                },
                component: () => import('@/views/desktop/asset/asset.vue')
            },
            {
                path: '/tools',
                name: "Tools",
                meta: {
                    requiresAuth: true
                },
                component: () => import('@/views/desktop/tools/tools.vue')
            },
            {
                path: '/ai-voice',
                name: "AiVoice",
                meta: {
                    requiresAuth: true
                },
                component: () => import('@/views/desktop/AiVoice/AiVoice.vue')
            },
        ]
    },
    {
        path: '/YJ-create',
        name: "YJCreate",
        meta: {
            requiresAuth: false
        },
        component: () => import('@/components/create/create.vue')
    },
    
    {
        path: '/YJ-generate/:bid',
        name: "YJGenerate",
        meta: {
            requiresAuth: false
        },
        component: () => import('@/components/create/generate.vue')
    },
    {
        path: '/YJ-select-avatar-voice/:bid',
        name: "YJSelectAvatarVoice",
        meta: {
            requiresAuth: false
        },
        component: () => import('@/components/create/select-avatar-voice.vue')
    },
    {
        path: "/login",
        name: "login",
        meta: {
            requiresAuth: false,
            type: 'login'
        },
        component: () => import('@/views/desktop/emailLogin/emailLogin.vue'),
    },
    {
        path: "/register",
        name: "register",
        meta: {
            requiresAuth: false,
            type: 'register'
        },
        component: () => import('@/views/desktop/emailLogin/emailLogin.vue'),
    },
    {
        path: "/price",
        name: "price",
        meta: {
            requiresAuth: false,
            type: 'register'
        },
        component: () => import('@/views/desktop/price/price.vue'),
    },
    {
        path: "/edit/:bid",
        name: "edit",
        meta: {
            requiresAuth: false
        },
        component: isMobileDevice() ? () => import('@/views/mobile/PPTedit/PPTedit.vue') : () => import('@/views/desktop/PPTedit/PPTedit.vue')
        // component:  () => import('@/components/edit/edit.vue')
    },
    {
        path: "/YJ-edit/:bid",
        name: "YJEdit",
        meta: {
            requiresAuth: false
        },
        component:  () => import('@/components/edit/edit.vue')
    },
    {
        path: "/my-account",
        name: "my-account",
        meta: {
            requiresAuth: false
        },
        component: () => import('@/views/desktop/Account/account.vue')
    },
    {
        path: "/permiEdit/:id/:mid",
        name: "permiEdit",
        meta: {
            requiresAuth: false
        },
        component: () => import('@/views/desktop/permi/permiEdit.vue')
    },
    {
        path: "/play/:bid",
        name: "play",
        meta: {
            requiresAuth: false
        },
        beforeEnter: (to, from, next) => {
            // 检查是否从特定的路由跳转过来
            // if (from.path === '/') {
            console.log('from')

            console.log(from)
            console.log(to)
            console.log(to.params.bid)
            fromAuthor({ documentId: to.params.bid }).then((res) => {
                console.log(res)
                if (res.code == 200) {
                    if (res.data === true) {
                        to.query.isNewDoc = false
                    } else {
                        to.query.isNewDoc = true
                    }
                    next();
                }
            }).catch((err) => {
                next(false);
            })
            console.log('from')
        },//() => import('@/views/desktop/PPTplay/PPTplay.vue')
        component: isMobileDevice() ? () => import('@/views/mobile/PPTplay/PPTplay.vue') : () => import('@/views/desktop/PPTplay/PPTplay.vue')
    },
    {
        path: "/preview/:bid",
        name: "preview",
        meta: {
            requiresAuth: false
        },
        beforeEnter: (to, from, next) => {
            // 检查是否从特定的路由跳转过来
            // if (from.path === '/') {
            console.log('from')

            console.log(from)
            console.log(to)
            console.log(to.params.bid)
            fromAuthor({ documentId: to.params.bid }).then((res) => {
                console.log(res)
                if (res.code == 200) {
                    if (res.data === true) {
                        to.query.isNewDoc = false
                    } else {
                        to.query.isNewDoc = true
                    }
                    next();
                }
            }).catch((err) => {
                next(false);
            })
            console.log('from')
        },//() => import('@/views/desktop/PPTplay/PPTplay.vue')
        component: isMobileDevice() ? () => import('@/views/mobile/PPTplay/PPTplay.vue') : () => import('@/views/desktop/preview/preview.vue')
    },
    {
        path: "/share_play/:bid",
        name: "share_play",
        meta: {
            requiresAuth: false
        },
        component: () => import('@/views/desktop/PPTplayShare/PPTplay.vue')
    },
    {
        path: "/permi/:bid",
        name: "permi",
        meta: {
            requiresAuth: true
        },
        component: () => import('@/views/desktop/PPTpermi/PPTpermi.vue')
    },
    // {
    //     path: "/t-play",
    //     name: "t-play",
    //     meta: {
    //         requiresAuth: true
    //     },
    //     component: () => import('@/views/desktop/threeplay/threeplay.vue')
    // },
    {
        path: "/share",
        name: "share",
        meta: {
            requiresAuth: false
        },
        component: () => import('@/views/desktop/PPTshare/PPTshare.vue')
    },
   
    { path: '/:catchAll(.*)', component: () => import('@/views/desktop/NotFound/NotFound.vue') } // 404 路由
];

const router = createRouter({
    routes,
    history: createWebHistory(),
    scrollBehavior() {
        return { top: 0 };
    },
});
router.beforeEach((to, from, next) => {
    const token = getToken();
    const user = getUserInfo();
    const isPublicPage = ['/login', '/register'].includes(to.path);
    store.dispatch("user/set_recharge", {recharge:false});
    if (to.matched.some(record => record.meta.requiresAuth)) {

        console.log(token)
        console.log(user)

        if (!token) {
            store.commit('app/SET_FROM_ROUTE', { name: from.name || 'Layout', params: from.params, query: from.query });
            store.commit('app/SET_TO_ROUTE', { name: to.name || 'Layout', params: to.params, query: to.query });
            Message.warning({ content: 'Please log in first', background: true, duration: 5 });
            // removeToken();
            // removeUserInfo();
            return next({ name: 'login' });
        }
        return next();
    } else {
        if (token && isPublicPage) {
            return next({ path: '/my-space' });
        }
        if (!isPublicPage) {
            store.commit('app/SET_FROM_ROUTE', { name: from.name || 'Layout', params: from.params, query: from.query });
            store.commit('app/SET_TO_ROUTE', { name: to.name || 'Layout', params: to.params, query: to.query });
        }
        return next();
    }
});
export default router;
